import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import Dot from 'components/common/Dot';
import Button from 'components/common/Button';
import styles from './CardSpectacle.module.css';
import tooltipStyles from 'styles/modules/Tooltip.module.css';
import catStyles from 'styles/modules/Categories.module.css';
import { ReactComponent as SpectaclesIcon } from 'icons/spectacle.svg';
import { ReactComponent as ConcertIcon } from 'icons/concert.svg';


let currentVisibleTooltip = null; // Variable globale au composant

const CardSpectacle = ({
  active,
  // categorieTarifaire,
  // configuration,
  description,
  // duration,
  // featured,
  // id,
  // licence,
  // lieu,
  name,
  plage_date,
  poster,
  // prive,
  // salle,
  // slug,
  // spectacleDate,
  // spectacleGenre,
  typeShow,
  link,
  buttonText = 'Commander',
  buttons = [],
  isFeatured = false,
}) => {


  return (
    <li className={styles.card}>
      {isFeatured && (
        <div
          className={`
                          ${styles.featuredTag}
                          ${typeShow?.code === 'concert' ? styles.featuredConcert : ''}
                          ${typeShow?.code === 'spectacle' ? styles.featuredSpectacle : ''}
                        `}
        >
          {typeShow?.code === 'spectacle' && (
            <SpectaclesIcon className={styles.icon} />
          )}
          {typeShow?.code === 'concert' && (
            <ConcertIcon className={styles.icon} />
          )}
          <span className={styles.featuredText}>À la une</span>
        </div>
      )}


      {/* Thumbnail */}
      <div className={`${styles.thumbnailContainer} ${typeShow?.code === 'concert' ? styles.thumbnailContainerConcert : ''}`}>

        {typeShow?.code === 'spectacle' && (
          <div className={styles.categoryBadge} aria-label="Type : Spectacle">
            <SpectaclesIcon className={styles.categoryIcon} />
            <span>Spectacle</span>
          </div>
        )}
        {typeShow?.code === 'concert' && (
          <div className={`${styles.categoryBadge} ${styles.categoryBadgeConcert}`} aria-label="Type : Concert">
            <ConcertIcon className={styles.categoryIcon} />
            <span>Concert</span>
          </div>
        )}


        <img
          src={poster?.path || '/images/card/card-no-image.jpg'}
          alt={`Affiche du ${typeShow?.code === 'concert' ? 'concert' : 'spectacle'} ${name}`}
          className={styles.thumbnail}
        />

      </div>

      {/* Content */}
      <div className={styles.content}>

        {/* Title and Date */}
        <div className={styles.headingContainer}>
          <Link to={link}>
            <h3 className={styles.title}>{name}</h3>
          </Link>
          {plage_date && <p className={`${styles.date} ${typeShow?.code === 'concert' ? styles.dateConcert : ''}`}>{plage_date}</p>}
        </div>

        {/* Description/Excerpt */}
        {description && (
          <div
            className={styles.excerpt}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}

        {/* Buttons */}
        <div className={styles.buttons}>
          {buttons.length > 0 ? (
            buttons.map((btn, index) => (
              <Link to={btn.href} key={index}>
                <Button
                  variant={btn.variant}
                  href={btn.href}
                  target={btn.target}
                  rel={btn.rel}
                  ariaLabel={`${btn.text} pour ${name}`}
                >
                  {btn.text}
                </Button>
              </Link>
            ))
          ) : (
            <Button 
              variant={typeShow?.code === 'concert' ? "secondary" : "primary"} 
              className={styles.cardButton}
              ariaLabel={`${buttonText} pour le ${typeShow?.code === 'concert' ? 'concert' : 'spectacle'} ${name}`}
            >
              <Link to={link}>{buttonText}</Link>
            </Button>
          )}
        </div>
      </div>
    </li>
  );
};

CardSpectacle.propTypes = {
  active: PropTypes.bool,
  // categorieTarifaire,
  // configuration,
  description: PropTypes.string,
  // duration,
  // featured,
  // id,
  // licence,
  // lieu,
  name: PropTypes.string,
  plage_date: PropTypes.string,
  poster: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    path: PropTypes.string,
  }),
  // prive,
  // salle,
  // slug,
  // spectacleDate,
  // spectacleGenre,
  typeShow: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    code: PropTypes.string,
  }),
  link: PropTypes.string,
  buttonText: PropTypes.string,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      variant: PropTypes.string,
      href: PropTypes.string,
      text: PropTypes.string,
      target: PropTypes.string,
      rel: PropTypes.string,
    })
  ),
  isFeatured: PropTypes.bool,
};

export default CardSpectacle;
